import React, { useEffect, useRef, useState,Suspense } from 'react';
import bestWinIcon from '../static/img/icon-section/best-win.png';
import providerIcon from '../static/img/icon-provider/1x2gaming-icon.png';
import slideImg1 from '../static/img/slide-1.jpg';

import Game from '../../../class/Game/Game.js';
import Games from '../../../class/Game_copy/Game.js';
import AuthService from '../../../class/services/AuthService';

import { useTranslation } from 'react-i18next';


import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Компонент для відображення картки перемоги
const BestWinCard = ({ imageSrc, providerName, winAmount,username }) => (
 
   
    <div className="card">
      <div className="card-img">
        <img src={imageSrc} alt={providerName} className="img-fluid" loading="lazy" />
      </div>
      <div className="CasinoGameCard_info CasinoGameCard_withProvider">
        <div className="CasinoGameCard_provider">
        { /*  <img alt="Providers name" src={providerIcon} className="CasinoGameCard_icon"  /> */}
          <p className="CasinoGameCard_name">{providerName}</p>
        </div>
        <p className="CasinoGameCard_gameName">{username}</p>
      </div>
      <h3 className="best-win"><strong>{winAmount}</strong></h3>
    </div>
);

const BestWinsSlider = ({ selection }) => {
  const { t } = useTranslation();
  const carouselRef = useRef(null);
  const [bestWins, setBestWins] = useState([]); 
  const [isLoading, setIsLoading] = useState(true); 
  const sliderRef = useRef(null); // Створюємо посилання на слайдер
  if (selection == undefined) {
    selection = '';
  }

  
  useEffect(() => {
    Games.getBestWin(selection, AuthService.getCustom('currency'))
      .then((data) => {
        if (data.status == "ok") {
          setBestWins(data.params.best_wins);
        } else {
          setBestWins([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching best wins:', error);
        setBestWins([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);


  useEffect(() => {

    if (!carouselRef.current || bestWins.length === 0) return;
  
    // Re-initialize the carousel each time `bestWins` is updated
    const bootstrap = require('bootstrap');
    const carousel = new bootstrap.Carousel(carouselRef.current, {
      interval: 3000,
      ride: 'carousel',
    });
  
    // Dispose of the carousel when the component unmounts
    return () => carousel.dispose();
  }, [bestWins]);
 
  
  
  
  
  

  useEffect(() => {
    if (bestWins.length === 0 || !carouselRef.current) return;
  
    const items = carouselRef.current.querySelectorAll('.carousel-item');
  
    if (items.length > 0) {
      items[0].classList.add('active'); // Mark the first item as active
    }
  
    const minPerSlide = 6;
  
    // Ensure that items are properly cloned without interfering with Bootstrap's internal DOM
    items.forEach((el) => {
      let next = el.nextElementSibling;
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          next = items[0]; // Wrap carousel by using first child
        }
        const cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }, [bestWins]);
 
  

  if (!isLoading && bestWins.length === 0) {
    return null; // Якщо даних немає, нічого не рендеримо!!!!!!!!!!
  }

  if (!isLoading && bestWins.length < 3) {
    return null; // Якщо менше 3-х перемог — теж нічого не рендеримо
  }
  

  const totalWins = bestWins.length;
  const slidesToShow = totalWins >= 6 ? 6 : totalWins;
  const slidesToScroll = Math.max(1, Math.floor(slidesToShow / 2));

  const settings = {
    dots: false,
    infinite: totalWins > slidesToShow,
    speed: 800,
    slidesToShow,
    slidesToScroll,
    autoplay: true, // Автоматична прокрутка
    autoplaySpeed: 3000, // Час між змінами
    pauseOnHover: true,
    ref: sliderRef,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(4, totalWins), slidesToScroll: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: Math.min(3, totalWins), slidesToScroll: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: Math.min(2, totalWins), slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="box-best-win-complete">
      <div className="body main-layout-item best-win-title ColumnSection_list">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a href="#" className="HomeSection_header">
                <img alt="Best Win" src="/assets/img/icon-section/best-win.png" className="HomeSection_icon" />
                <div className="HomeSection_label">{t('Best_Win')}</div>
                <div className="HomeSection_right"></div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="justify-content-center multi-slider-box">
      <Suspense fallback={<div>{t('loading')}...</div>}>
      
          <Slider {...settings} ref={sliderRef}>
            {bestWins.map((win, index) => (
              <BestWinCard
                key={index}
                imageSrc={win.game_image}
                providerName={win.game_name}
                username={win.username}
                winAmount={win.amount}
              />
            ))}
          </Slider>


        
        </Suspense>
      </div>
    </div>
  );
};

export default BestWinsSlider;
